export function Constants() {
  angular.module("classkickApp").constant("constants", {
    version: "5.297.0-4bb96b1",
    backend: "webservices",
    projectId: "classkick-907",
  })
}
